module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-footy-lives-here-mobile.4ef67f87.jpg";